import { nextTick, ref } from "vue";
import { useLayoutMode } from "./useLayoutMode";
export var WRITE_TAB_TYPE;
(function (WRITE_TAB_TYPE) {
    WRITE_TAB_TYPE["BASIC_INFO"] = "\uACAC\uC801\uC11C";
    WRITE_TAB_TYPE["CALC_COST"] = "\uC0B0\uCD9C\uB0B4\uC5ED\uC11C";
    WRITE_TAB_TYPE["BOM_LIST"] = "BOM LIST";
})(WRITE_TAB_TYPE || (WRITE_TAB_TYPE = {}));
const tabItems = [
    WRITE_TAB_TYPE.BASIC_INFO,
    WRITE_TAB_TYPE.CALC_COST,
    WRITE_TAB_TYPE.BOM_LIST,
];
const maxStep = tabItems.length - 1;
export const useWriteTab = () => {
    const writeTab = ref(0);
    const writeTabItems = ref(tabItems);
    const { layoutMode, showLeftPanel, showRightPanel, leftCols, rightCols, setLayoutMode, } = useLayoutMode();
    const goNext = () => {
        if (writeTab.value < maxStep && writeTab.value >= 0) {
            writeTab.value++;
        }
    };
    const goPrev = () => {
        if (writeTab.value > 0 && writeTab.value <= maxStep) {
            writeTab.value--;
        }
    };
    const goToBasicInfo = () => {
        writeTab.value = 0;
    };
    const goToCalcCost = async () => {
        writeTab.value = 1;
        await nextTick();
    };
    const goToBOMList = () => {
        writeTab.value = 2;
    };
    return {
        writeTab,
        writeTabItems,
        goNext,
        goPrev,
        goToBasicInfo,
        goToCalcCost,
        goToBOMList,
        layoutMode,
        showLeftPanel,
        showRightPanel,
        leftCols,
        rightCols,
        setLayoutMode,
    };
};
